// extracted by mini-css-extract-plugin
module.exports = {"base_button":"styles_base_button__2LGXA"};